/**
 * Council Trail v0 — useLens hook.
 *
 * Throw-if-missing pattern: callers must be inside a LensProvider.
 * Loud failure beats a silent `undefined` propagating through chrome.
 */
import { useContext } from 'react';

import { LensContext, type LensContextValue } from '../contexts/LensContext';

export function useLens(): LensContextValue {
  const ctx = useContext(LensContext);
  if (!ctx) throw new Error('useLens must be used within LensProvider');
  return ctx;
}
